// extracted by mini-css-extract-plugin
export default {"root":"PlasmicReturnToSection_root__tcFVn"};